// 适用于ag-grid
import { throttle } from 'lodash';

export default {
    data() {
        return {
            targetTableWrapperEl: null,
            initCount: 0,
        };
    },
    mounted() {
        this.isMounted = true;
        this.initScrollBar();
    },
    deactivated() {
        this.isMounted = false;
        this.destory();
    },
    beforeDestroy() {
        this.destory();
    },
    activated() {
        if (this.isMounted) return;
        this.initScrollBar();
    },
    methods: {
        initScrollBar() {
            if (!this.isNeedScrollBar) return; // 是否需要滚动条
            this.targetTableWrapperEl = this.$refs.gridRef.$el;
            if (!this.targetTableWrapperEl) {
                setTimeout(() => {
                    this.initCount += 1;
                    if (this.initCount > 3) {
                        return;
                    }
                    this.initScrollBar();
                }, 1000);
                return;
            }
            this.scrollBarEle = this.targetTableWrapperEl.querySelector('.ag-body-horizontal-scroll');
            this.checkIsScrollBottom();

            // 全局判断是否需要显示scroller
            const scrollContainer = document.querySelector('.layout-main');
            scrollContainer.addEventListener('scroll', this.checkIsScrollBottom, true);
            // resize
            window.addEventListener(
                'resize',
                () => {
                    this.checkIsScrollBottom();
                },
                true,
            );
            // 监听滚动盒子的dom变化，自动重新设置，用于表格高度变化+查询表单的展开收起变化
            this.tableElObserver = new MutationObserver(() => {
                setTimeout(() => {
                    this.checkIsScrollBottom();
                }, 0);
            });
            this.tableElObserver.observe(scrollContainer, {
                childList: true,
                subtree: true,
                attributes: true,
            });
        },

        /**
         * 滚动条显示或隐藏
         */
        checkIsScrollBottom: throttle(function () {
            const that = this;
            const viewHeight = window.innerHeight || document.documentElement.clientHeight;
            const { bottom } = that.targetTableWrapperEl.getBoundingClientRect();
            // console.log(2222, bottom, viewHeight);
            if (bottom <= viewHeight) {
                that.hideScroller();
            } else {
                // 显示当前的bar
                that.showScroller();
            }
        }, 1000 / 60),

        /**
         * 显示整体
         */
        showScroller() {
            const { targetTableWrapperEl } = this;
            const width = targetTableWrapperEl.clientWidth;
            this.scrollBarEle.style.position = 'fixed';
            this.scrollBarEle.style.bottom = '0';
            this.scrollBarEle.style.width = `${width}px`;
        },

        /**
         * 隐藏整体
         */
        hideScroller() {
            this.scrollBarEle.style.position = 'initial';
            this.scrollBarEle.style.width = '';
        },

        destory() {
            if (!this.isNeedScrollBar) return;
            console.log('destory');
            this.tableElObserver.disconnect();
            const scrollContainer = document.querySelector('.layout-main');
            scrollContainer.removeEventListener('scroll', this.checkIsScrollBottom, true);
            window.removeEventListener(
                'resize',
                () => {
                    this.checkIsScrollBottom();
                },
                true,
            );
        },
    },
};
